import { axiosConfig } from '../api/axios-config.js'

// iTracker
export const itracker = {
  getHubs: (token) => axiosConfig.get('/api/itracker/hubs', token),
  getHub: (id, token) => axiosConfig.get(`/api/itracker/hubs/${id}`, token),
  createHub: (data, token) => axiosConfig.post('/api/itracker/hubs', data, token),
  updateHub: (id, data, token) => axiosConfig.patch(`/api/itracker/hubs/${id}`, data, token),
  changeHubStatus: (id, data, token) => axiosConfig.put(`/api/itracker/hubs/${id}`, data, token),
  deleteHub: (id, token) => axiosConfig.delete(`/api/itracker/hubs/${id}`, token),

  getTags: (token) => axiosConfig.get('/api/itracker/tags', token),
  getTag: (id, token) => axiosConfig.get(`/api/itracker/tags/${id}`, token),
  createTag: (data, token) => axiosConfig.post('/api/itracker/tags', data, token),
  updateTag: (id, data, token) => axiosConfig.patch(`/api/itracker/tags/${id}`, data, token),
  changeTagStatus: (id, data, token) => axiosConfig.put(`/api/itracker/tags/${id}`, data, token),
  deleteTag: (id, token) => axiosConfig.delete(`/api/itracker/tags/${id}`, token),

  getPermissions: (tagId, token) => axiosConfig.get(`/api/itracker/tags/${tagId}/permissions`, token),
  updatePermissions: (tagId, data, token) => axiosConfig.put(`/api/itracker/tags/${tagId}/permissions`, data, token),

  getNotifyLogs: (params, token) => axiosConfig.get('/api/itracker/notify-logs', { ...token, params })
}
